import { BaseService } from "./baseservice";

class ChartsServiceClass extends BaseService{
    
    async load(organizationID, kpiId, year) {
        // org/{org}/kpi/{kpiName}/date/{year}
        const url = '/org/' + organizationID + '/kpi/' + kpiId + '/date/' + year;
        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data;
        }
    }
}

let ChartsService = new ChartsServiceClass(ENVIRONMENT.API_HOST);
export default ChartsService;
